// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"cc9b53b7","307":"0e78f5b5","453":"874d65d5","741":"180782d4","898":"d2bc6984"}[chunkId] + ".chunk.js";
};